import { CardPageAgreementNotice, CardPageLayout } from '@/components/card-page-layout/CardPageLayout'

export default function CreateAccountPage() {
  return (
    <CardPageLayout footer={<CardPageAgreementNotice />}>
      <h1 className="text-center font-rethink-sans text-xl font-semibold leading-7 text-brand-neutral-950">Create your account</h1>
    </CardPageLayout>
  )
}
